module.exports = __webpack_public_path__ + "static/media/grid-active.dd204a21.svg";